export default {
  metadata: {
    version: '1.0.0',
    id: 'carousel-pagination-item-1.0.0',
    name: 'JDSCarouselPaginationItem'
  },
  hierarchy: {
    container: []
  },
  base: {
    container: {
      width: '{c_0}',
      height: '{c_1}',
      'background-color': '{c_2}',
      opacity: '{c_3}',
      'border-radius': '{c_4}',
      show: true,
      behavior: {
        hover: {
          'background-color': '{c_5}',
          opacity: '{c_6}'
        },
        active: {
          'background-color': '{c_7}',
          opacity: '{c_8}'
        }
      }
    }
  },
  variant: {
    density: {
      condensed: {
        container: {
          height: '{c_9}'
        }
      }
    },
    active: {
      true: {
        container: {
          opacity: '{c_10}',
          behavior: {
            hover: {
              'background-color': '{c_11}'
            },
            active: {
              'background-color': '{c_12}'
            }
          }
        }
      }
    },
    kind: {
      label: {
        container: {
          hidden: true
        }
      },
      none: {
        container: {
          hidden: true
        }
      }
    }
  },
  combination: [
    {
      condensed: {
        false: {
          normal: {
            container: {
              width: '{c_18}'
            }
          },
          tail_dot_large: {
            container: {
              width: '{c_19}',
              height: '{c_20}'
            }
          },
          tail_dot_small: {
            container: {
              width: '{c_21}',
              height: '{c_22}'
            }
          }
        },
        true: {
          normal: {
            container: {
              width: '{c_23}'
            }
          },
          tail_dot_large: {
            container: {
              width: '{c_24}'
            }
          },
          tail_dot_small: {
            container: {
              width: '{c_25}'
            }
          }
        }
      },
      relaxed: {
        false: {
          normal: {
            container: {
              width: '{c_13}'
            }
          },
          tail_dot_large: {
            container: {
              width: '{c_14}',
              height: '{c_15}'
            }
          },
          tail_dot_small: {
            container: {
              width: '{c_16}',
              height: '{c_17}'
            }
          }
        },
        true: {
          normal: {
            container: {
              width: '{c_26}'
            }
          },
          tail_dot_large: {
            container: {
              width: '{c_27}'
            }
          },
          tail_dot_small: {
            container: {
              width: '{c_28}'
            }
          }
        }
      }
    }
  ],
  combination_config: [['density', 'active', 'kind']],
  api: {
    config: {
      kind: {
        values: ['normal', 'tail_dot_large', 'tail_dot_small']
      },
      density: {
        values: ['relaxed', 'condensed']
      },
      active: {
        values: [false, true]
      }
    },
    events: {
      container: {
        onClick: 'onDotClick'
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'presentation'
          }
        }
      }
    },
    data: {}
  }
};
